<template>
  <ComboBoxInput
    v-if="show_list"
    v-model="values_clone.selected_expansion_list"
    name="team_member"
    :is-multiple="false"
    :disabled="disabled"
    :items="expansion_lists"
    classes="w-full mr-2 relative dark:text-white"
    label-attr="name"
    value-attr="id"
    label=""
    :placeholder="$t('Select List')"
    :allow-null="false"
    :floating-label="false">
    <template #item="{ item, active }">
      <li :class="[active ? 'text-white bg-blue' : 'text-gray-900 dark:text-white', 'cursor-default relative py-2 pl-4 pr-4 group/name']">
        <div class="flex items-center">
          <div class="ml-3">
            <p class="h-full text-sm font-normal text-gray-700 dark:text-white group-hover/name:text-white">
              {{ item.name }}
            </p>
          </div>
        </div>
      </li>
    </template>
  </ComboBoxInput>
</template>

<script>
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"

import dataService from "@/services/data.service"

export default {
  components: { ComboBoxInput },
  props: { selectedNode: null },
  emits: ["updateValues"],

  data() {
    return {
      values_clone: { selected_expansion_list: null },
      expansion_lists: [],
      show_list: false,
      disabled: false
    }
  },
  watch: {
    values_clone: {
      deep: true,
      handler() {
        this.handleUpdateValues()
      }
    }
  },

  created() {
    this.init()
  },

  methods: {
    handleUpdateValues() {
      let valid_calc = true
      if (!this.values_clone?.selected_expansion_list) {
        valid_calc = false
      }

      if (valid_calc) {
        const data = {
          ...this.values_clone,
          valid: valid_calc,
          meta: { name: `${this.expansion_lists.find((ex) => ex.id == this.values_clone.selected_expansion_list)?.name}` }
        }
        this.$emit("updateValues", data)
      }
    },
    init() {
      if (!this.selectedNode.data.values.selected_expansion_list) {
        this.show_list = true
      }
      dataService.getExpansionLists().then((result) => {
        this.expansion_lists = result.data.results
        this.values_clone = this.$utils.clone(this.selectedNode.data.values)
        this.show_list = true
      })
    }
  }
}
</script>
